<template>
  <div class="siu-wrap">
    <div class="siu-head">Signed in as</div>
    <div class="siu-card" :class="{ open: menuOpen }">
      <button class="siu-btn" @click="menuOpen = !menuOpen">
        <span class="siu-avatar">{{ initials }}</span>
        <span class="siu-info">
          <span class="siu-name">{{ userName }}</span>
          <span class="siu-role">{{ currentRole.shortLabel }}</span>
        </span>
        <svg class="siu-caret" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="6 9 12 15 18 9"/></svg>
      </button>
      <div v-if="menuOpen" class="siu-menu">
        <div
          v-for="role in roles"
          :key="role.id"
          class="siu-menu-item"
          :class="{ active: role.id === currentRole.id }"
          @click="selectRole(role.id)"
        >
          <svg v-if="role.id === 'internal'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
          <span>{{ role.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listAccessRoles, getCurrentAccessRole, setCurrentAccessRole } from './journeyAccess'
import { getCurrentUserName } from './currentUser'

export default {
  name: 'signed-in-user-panel',
  data () {
    return {
      menuOpen: false,
      userName: getCurrentUserName(),
      currentRole: getCurrentAccessRole()
    }
  },
  computed: {
    roles () {
      return listAccessRoles()
    },
    initials () {
      return this.userName.trim().charAt(0).toUpperCase() || '?'
    }
  },
  mounted () {
    this.onDocClick = e => { if (!this.$el.contains(e.target)) this.menuOpen = false }
    document.addEventListener('click', this.onDocClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onDocClick)
  },
  methods: {
    selectRole (roleId) {
      setCurrentAccessRole(roleId)
      this.currentRole = getCurrentAccessRole()
      this.menuOpen = false
    }
  }
}
</script>

<style scoped>
.siu-wrap{border-top:1px solid var(--card-border);padding:12px;flex-shrink:0}
.siu-head{font-size:10.5px;font-weight:600;color:var(--text-muted);text-transform:uppercase;letter-spacing:0.05em;margin-bottom:8px}
.siu-card{position:relative}
.siu-btn{
  width:100%;padding:8px;background:var(--card-label-bg);border:1px solid var(--card-border);border-radius:9px;
  display:flex;align-items:center;gap:8px;cursor:pointer;text-align:left;font-family:inherit;
}
.siu-card.open .siu-btn{border-color:var(--accent);box-shadow:0 0 0 3px rgba(20,184,166,0.22)}
.siu-avatar{
  width:28px;height:28px;border-radius:50%;background:linear-gradient(135deg,#14B8A6,#0D9488);color:#fff;
  display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;flex-shrink:0;
}
.siu-info{flex:1;overflow:hidden;display:flex;flex-direction:column}
.siu-name{font-size:12.5px;font-weight:600;color:var(--text);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.siu-role{font-size:10.5px;color:var(--text-faint);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.siu-caret{color:var(--text-muted);flex-shrink:0;transition:transform .15s}
.siu-card.open .siu-caret{transform:rotate(180deg)}
.siu-menu{
  /* Popup floats over the page rather than the dark sidebar rail, so it stays light. */
  --card:#ffffff;--card-border:#CBD5DF;--card-label-bg:#F6F8FA;
  --text:#16233A;--text-muted:#5D6C7E;--text-faint:#94A2B1;
  --accent:#0D9488;--accent-light:#0B7A70;
  position:absolute;bottom:calc(100% + 6px);left:0;right:0;
  background:var(--card);border:1px solid var(--card-border);border-radius:9px;
  box-shadow:0 12px 32px rgba(0,0,0,0.16);z-index:10;padding:6px;
}
.siu-menu-item{
  display:flex;align-items:center;gap:8px;padding:8px 9px;border-radius:6px;cursor:pointer;
  font-size:12px;color:var(--text);
}
.siu-menu-item:hover{background:var(--card-label-bg)}
.siu-menu-item.active{background:rgba(13,148,136,0.11);color:var(--accent-light);font-weight:600}
</style>



// WEBPACK FOOTER //
// SignedInUserPanel.vue?630f18f9